import jwt from 'jsonwebtoken'

const verifyToken = async (token, userLoggedId) => {
  const { userId } = decodeToken(token)
  return userLoggedId === userId
}

const decodeToken = token => {
  const decodedToken = jwt.decode(token)
  if (!decodedToken) return false
  const userId = decodedToken.userID
  const iat = decodedToken.iat
  return { userId, iat }
}

export default {
  verifyToken,
  decodeToken
}
